import { Action } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { USER_PICKUP_SHOP_LIST } from '../checkout-state';

export const LOAD_USER_PICKUP_SHOP_LIST = '[Checkout] Load user pickup shop list';
export const LOAD_USER_PICKUP_SHOP_LIST_SUCCESS = '[Checkout] Load user pickup shop list success';
export const LOAD_USER_PICKUP_SHOP_LIST_FAIL = '[Checkout] Load user pickup shop list fail';
export const LOAD_USER_PICKUP_SHOP_LIST_RESET = '[Checkout] Load user pickup shop list reset';

export const ADD_USER_PICKUP_SHOP = '[Checkout] Add user pickup shop';
export const ADD_USER_PICKUP_SHOP_SUCCESS = '[Checkout] Add user pickup shop success';
export const ADD_USER_PICKUP_SHOP_FAIL = '[Checkout] Add user shop pickup fail';

export const REMOVE_USER_PICKUP_SHOP = '[Checkout] Remove user pickup shop';
export const REMOVE_USER_PICKUP_SHOP_SUCCESS = '[Checkout] Remove user pickup shop success';
export const REMOVE_USER_PICKUP_SHOP_FAIL = '[Checkout] Remove user pickup shop fail';

export class LoadUserPickupShopList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_USER_PICKUP_SHOP_LIST;

  constructor() {
    super(USER_PICKUP_SHOP_LIST);
  }
}

export class LoadUserPickupShopListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_USER_PICKUP_SHOP_LIST_SUCCESS;

  constructor(public payload: Pos[]) {
    super(USER_PICKUP_SHOP_LIST);
  }
}

export class LoadUserPickupShopListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_USER_PICKUP_SHOP_LIST_FAIL;

  constructor(public payload: unknown) {
    super(USER_PICKUP_SHOP_LIST, payload);
  }
}

export class LoadUserPickupShopListReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_USER_PICKUP_SHOP_LIST_RESET;

  constructor() {
    super(USER_PICKUP_SHOP_LIST);
  }
}

export class AddUserPickupShop implements Action {
  readonly type = ADD_USER_PICKUP_SHOP;

  constructor(public payload: { shopName: string }) {}
}

export class AddUserPickupShopSuccess implements Action {
  readonly type = ADD_USER_PICKUP_SHOP_SUCCESS;

  constructor(public payload: { shopName: string }) {}
}

export class AddUserPickupShopFail implements Action {
  readonly type = ADD_USER_PICKUP_SHOP_FAIL;

  constructor(public payload: { shopName: string; error: unknown }) {}
}

export class RemoveUserPickupShop implements Action {
  readonly type = REMOVE_USER_PICKUP_SHOP;

  constructor(public payload: { shopName: string }) {}
}

export class RemoveUserPickupShopSuccess implements Action {
  readonly type = REMOVE_USER_PICKUP_SHOP_SUCCESS;

  constructor(public payload: { shopName: string }) {}
}

export class RemoveUserPickupShopFail implements Action {
  readonly type = REMOVE_USER_PICKUP_SHOP_FAIL;

  constructor(public payload: { shopName: string; error: unknown }) {}
}

export type UserPickupShopsActions =
  | LoadUserPickupShopList
  | LoadUserPickupShopListSuccess
  | LoadUserPickupShopListFail
  | LoadUserPickupShopListReset
  | AddUserPickupShop
  | AddUserPickupShopSuccess
  | AddUserPickupShopFail
  | RemoveUserPickupShop
  | RemoveUserPickupShopSuccess
  | RemoveUserPickupShopFail;
